import { useGetOrganisationById } from "../services/organisationService";
import { useAuth } from "./useAuth";

export const useLogo = () => {
  const { orgId } = useAuth();
  // Changed to handle null case properly
  const { data: org, isLoading } = useGetOrganisationById(orgId || undefined);
  
  return { 
    logo: org?.logo, 
    isLoading 
  };
};